import angular from 'angular';
import stExtrasComponent from './stExtras.component';
import splitTranslationWithLink from '../filters/extractAndCreateTranslationLink';

let stExtrasModule = angular.module('stExtras', [
    splitTranslationWithLink
])
    .component('stExtras', stExtrasComponent)
    .name;

export default stExtrasModule;



// WEBPACK FOOTER //
// ./client/app/common/stExtras/stExtras.js